// ============================================================================
// COMMISSION ESTIMATOR — CONFIGURATION
// Edit the values below to change pricing. No calculator logic lives here.
// ============================================================================

export const COMMISSION_CONFIG = {
  // Canvas sizes · "Starting Commission Investment". `price: null` = custom quote.
  sizes: [
    { id: "12x12", label: '12" × 12"', price: 1250 },
    { id: "16x20", label: '16" × 20"', price: 2400 },
    { id: "18x24", label: '18" × 24"', price: 3500 },
    { id: "24x24", label: '24" × 24"', price: 4000 },
    { id: "24x36", label: '24" × 36"', price: 5250 },
    { id: "30x40", label: '30" × 40"', price: 7000 },
    { id: "36x48", label: '36" × 48"', price: 8500 },
    { id: "48x48", label: '48" × 48"', price: 10500 },
    { id: "48x60", label: '48" × 60"', price: 12500 },
    { id: "custom", label: "Custom / Larger", price: null },
  ],

  // Primary figures / portraits. `pct` is added to the base. `custom: true` = custom quote.
  figures: [
    { id: "none", label: "No specific portrait", pct: 0 },
    { id: "1", label: "1 person", pct: 0, note: "Included" },
    { id: "2", label: "2 people", pct: 0.1 },
    { id: "3", label: "3 people", pct: 0.2 },
    { id: "4plus", label: "4+ people", custom: true },
  ],

  // Additional subjects (multi-select). Priced by count, not per item.
  complexity: {
    options: [
      "Horse / Animal",
      "Detailed Landscape",
      "Architecture / Building",
      "Vehicle",
      "Detailed Background",
      "Multiple Important Objects",
    ],
    pctPerSelection: 0.05,
    capPct: 0.2,
    customQuoteAt: 4, // this many or more selections → custom quote
  },

  // Timeline
  timelines: [
    { id: "standard", label: "Standard Timeline", pct: 0, note: "Typically 6–12 weeks" },
    { id: "date", label: "Specific Date", pct: 0, note: "Tell me the date you have in mind" },
    { id: "rush", label: "Priority / Rush", pct: 0.25, note: "Subject to studio schedule" },
  ],

  // Estimate presentation
  minimumPrice: 1250,
  roundTo: 100, // round displayed numbers to this increment
  rangeSpread: 0.05, // ±5% around the computed figure

  // Optional inspiration tags — organizational only, never affect price
  tags: [
    "Black Western",
    "Cowboy / Cowgirl",
    "Portrait",
    "Family",
    "Legacy",
    "Colorado",
    "Kansas",
    "Abstract",
    "Floral",
    "Music",
    "Cultural",
    "Memorial",
    "Fraternity / Organization",
    "Other",
  ],

  // Reference images
  maxUploads: 5,
  maxUploadMb: 12,
  acceptedTypes: ".jpg,.jpeg,.png,.webp,.heic,.heif,image/jpeg,image/png,image/webp,image/heic,image/heif",

  // Description
  descriptionMaxChars: 1500,

  // "How did you hear about Joseph" options
  referralSources: [
    "Instagram",
    "TikTok",
    "Facebook",
    "Google search",
    "Gallery / exhibition",
    "Friend or collector",
    "Press / article",
    "Other",
  ],
};
